// @ts-nocheck
import loadProductByPath from "@insite/client-framework/Store/Data/Products/Handlers/LoadProductByPath";
import {
    chain,
    LoadProductIfNeeded,
} from "@insite/client-framework/Store/Pages/ProductDetails/Handlers/DisplayProduct";
import { executeAwaitableHandlerChain, replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";

replaceInChain(chain, LoadProductIfNeeded, async props => {
    if (props.product && props.product.variantTypeId === null) {
        /* Store Removed Code - if */
        props.dispatch(
            loadProductByPath({
                ...props.parameter,
                addToRecentlyViewed: true,
                onComplete: productProps => {
                    const configuration = productProps?.apiResult?.detail?.configuration;
                    if (configuration) {
                        props.dispatch({
                            type: "Pages/ProductDetails/InitConfigurationSelection",
                            configuration,
                        });
                    }

                    /* Store Removed Code - dispatch */
                },
            }),
        );
        /* Store Removed Code - else & getProductByPath */
    }

    props.product = await executeAwaitableHandlerChain(
        loadProductByPath,
        { ...props.parameter, addToRecentlyViewed: true },
        props,
    );
});
